/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { NavLink, useLocation } from 'react-router-dom';
import {
  ListItem,
  Collapse,
  Box,
  IconButton,
  Button,
  useMediaQuery,
} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageListItem from '@mui/material/ImageListItem';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonIcon from '@mui/icons-material/Person';
import inetlogo from '../../assets/images/inetlogo.png';
import { Hidden } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { PassportAuth } from '../../contexts/AuthContext';

const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  backgroundColor: '#007CC2',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  backgroundColor: '#007CC2',
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const items = [
  {
    href: '/CreatePayment',
    icon: AccountBalanceIcon,
    title: 'สร้างรายการชำระเงิน',
    sub: [],
  },
  {
    href: '/History',
    icon: HistoryIcon,
    title: 'ประวัติการทำรายการ',
    sub: [],
  },
];

export default function MiniDrawer({
  onMobileClose,
  openMobile,
  children,
  open,
  setOpen,
}) {
  const { handleSignout } = useContext(PassportAuth);

  const onSignOut = async () => {
    await handleSignout();
  };
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openSubSidebar, setOpenSubSidebar] = useState([]);

  const location = useLocation();

  const handleClick = (item) => {
    if (openSubSidebar.includes(item.title)) {
      setOpenSubSidebar(openSubSidebar.filter((title) => title !== item.title));
    } else {
      setOpenSubSidebar([...openSubSidebar, item.title]);
    }
    if (item.href) {
      onMobileClose(); // Close the drawer when an item with a non-empty href is clicked
    }
  };

  const isSubSidebarOpen = (title) => openSubSidebar.includes(title);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const renderSubItems = (subItems, margin) =>
    subItems.map((subItem, index) => (
      <div key={index}>
        {subItem?.sub?.length > 0 ? (
          <div>
            <ListItem
              className="hover:bg-emerald-900 cursor-pointer"
              sx={{
                color: '#949494',
                marginLeft: margin,
                fontSize: '16px',
                '&:hover': { backgroundColor: '#45A6F5' },
              }}
              onClick={() => handleClick(subItem)}
            >
              <ListItemIcon
                sx={{
                  color: '#949494',
                  fontSize: '16px',
                  '&:hover': { color: '#FFF' },
                }}
              >
                <subItem.icon />
              </ListItemIcon>
              <ListItemText
                primary={subItem.title}
                sx={{ marginLeft: -1, color: '#fff' }}
              />
              {isSubSidebarOpen(subItem.title) ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItem>
            <Collapse
              in={isSubSidebarOpen(subItem.title)}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {renderSubItems(subItem.sub, margin + 2)}
              </List>
            </Collapse>
          </div>
        ) : (
          <NavLink
            to={subItem.href}
            key={index}
            onClick={() => subItem.href && onMobileClose()}
          >
            <ListItem
              className="hover:bg-emerald-900 cursor-pointer"
              sx={{
                ...(subItem.href === location.pathname && {
                  backgroundColor: '#45A6F5',
                  borderRadius: 3,
                  color: '#FFF',
                }),
                '&:hover': { backgroundColor: '#45A6F5' },
              }}
            >
              <ListItemIcon sx={{ '&:hover': { color: '#FFF' } }}>
                {subItem.href === location.pathname ? (
                  <subItem.icon sx={{ color: '#fff', marginLeft: margin }} />
                ) : (
                  <subItem.icon sx={{ marginLeft: margin, color: '#fff' }} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={subItem.title}
                sx={{ marginLeft: margin - 1, color: '#fff' }}
              />
            </ListItem>
          </NavLink>
        )}
      </div>
    ));

  const renderItems = () =>
    items.map((item, index) => (
      <div key={index}>
        {item.sub.length > 0 ? (
          <div>
            <ListItem
              className="hover:bg-emerald-900 cursor-pointer"
              onClick={() => handleClick(item)}
              sx={{
                marginLeft: -0.2,
                color: '#fff',
                '&:hover': { backgroundColor: '#45A6F5' },
              }}
            >
              <ListItemIcon
                sx={{ color: '#fff', '&:hover': { color: '#FFF' } }}
              >
                <item.icon />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                sx={{ marginLeft: -1, color: '#fff' }}
              />
              {isSubSidebarOpen(item.title) ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={isSubSidebarOpen(item.title)}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {renderSubItems(item.sub, 2)}
              </List>
            </Collapse>
          </div>
        ) : (
          <NavLink
            to={item.href}
            key={index}
            onClick={() => item.href && onMobileClose()}
          >
            <ListItem
              className="hover:bg-emerald-900 cursor-pointer"
              sx={{
                ...(item.href === location.pathname && {
                  backgroundColor: '#45A6F5',
                  borderRadius: 3,
                  color: '#FFF',
                }),
                '&:hover': { backgroundColor: '#45A6F5' },
              }}
            >
              <ListItemIcon sx={{ '&:hover': { color: '#FFF' } }}>
                {item.href === location.pathname ? (
                  <item.icon />
                ) : (
                  <item.icon sx={{ color: '#fff' }} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                sx={{ marginLeft: -1, color: '#fff' }}
              />
            </ListItem>
          </NavLink>
        )}
      </div>
    ));

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Hidden lgDown>
        <Drawer variant="permanent" open={open}>
          <ListItem disablePadding sx={{ display: 'flex' }}>
            <ListItemButton
              onClick={() => {
                if (open) {
                  handleDrawerClose();
                } else {
                  handleDrawerOpen();
                }
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                color: '#fff',
              }}
            >
              <ImageListItem sx={{ maxWidth: open ? '60px' : '70px' }}>
                <img src={`${inetlogo}`} alt="INET Logo" />
              </ImageListItem>
              <ListItemText
                sx={{ opacity: open ? 1 : 0, ml: open ? '10px' : 0 }}
              >
                <div className="text-sm">Internet Thailand</div>
                <div className="text-sm">Public Company Limited</div>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <List sx={{}}>{renderItems()}</List>
        </Drawer>
      </Hidden>
      <Hidden lgUp>
        <MuiDrawer
          variant="temporary"
          open={openMobile}
          onClose={onMobileClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: '#007CC2',
            },
          }}
        >
          <DrawerHeader style={{ display: 'flex', justifyContent: 'end' }}>
            <ImageListItem sx={{ maxWidth: open ? '60px' : '70px' }}>
              <img src={`${inetlogo}`} alt="INET Logo" />
            </ImageListItem>
            <ListItemText sx={{ opacity: open ? 1 : 0, ml: open ? '10px' : 0 }}>
              <div className="text-sm" style={{ color: '#fff' }}>
                Internet Thailand
              </div>
              <div className="text-sm" style={{ color: '#fff' }}>
                Public Company Limited
              </div>
            </ListItemText>
            <IconButton onClick={onMobileClose}>
              <CloseIcon sx={{ color: '#fff' }} />
            </IconButton>
          </DrawerHeader>
          <List sx={{}}>{renderItems()}</List>
          <div className="flex flex-col justify-center items-center ">
            <Button
              size="small"
              startIcon={<i className="fas fa-fingerprint" />}
              variant="outlined"
              onClick={onSignOut}
              sx={{ color: '#ff0000', backgroundColor: '#fff', margin: '10px' }}
            >
              ออกจากระบบ
            </Button>
          </div>
        </MuiDrawer>
      </Hidden>
      <Box component="main" sx={{ flexGrow: 1, p: 3, overflowX: 'auto' }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}
